import { normalizeCountryName } from '@heidi/growth';
import { loadIso3166 } from '@heidi/utils/iso3166-lazy';

/**
 * Async because `iso-3166-2` is lazy-loaded (ARC-194). Called from the
 * Save handler in `evidence-onboarding-modal`, where awaiting is cheap —
 * the module typically resolves on first JurisdictionSelect mount earlier
 * in the flow, so this resolves synchronously from cache by the time the
 * user clicks Save.
 */
export const isJurisdictionValidForCountry = async ({
  jurisdictionCode,
  countryName,
}: {
  jurisdictionCode: string;
  countryName?: string | null;
}): Promise<boolean> => {
  const iso3166 = await loadIso3166();
  const subdivision = iso3166.subdivision(jurisdictionCode);
  if (!subdivision) return false;

  if (!countryName) return true;

  const normalizedCountryName = normalizeCountryName(countryName) ?? countryName;
  const countryCandidates = [normalizedCountryName, countryName].filter(
    (name, index, values): name is string =>
      Boolean(name) && values.indexOf(name) === index
  );

  const subdivisionCountryName = subdivision.countryName.trim().toLowerCase();
  return countryCandidates.some((candidate) => {
    const country = iso3166.country(candidate);
    return country?.name
      ? country.name.trim().toLowerCase() === subdivisionCountryName
      : false;
  });
};
